import PropTypes from 'prop-types';

export const ActionItemsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    text: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    onClick: PropTypes.func,
  }),
);

export const PhysicianContextMenuPropTypes = {
  actionItems: ActionItemsPropType,
  registerFileInput: PropTypes.func,
  t: PropTypes.func,
  isWideScreen: PropTypes.bool,
  isDisabled: PropTypes.bool,
  setValue: PropTypes.func,
  insertSnippet: PropTypes.func,
};

export const ComposerContextMenuPropTypes = {
  ...PhysicianContextMenuPropTypes,
  id: PropTypes.string,
};
